module.exports = __webpack_public_path__ + "img/Bear02.c3fb28c5.jpg";